const ALLOW_YEARS_PR = 31;
const ALLOW_YEARS_CR_CO = 31;

export const getYear = (branch: string): number =>
  new Date().getFullYear() -
  (branch === 'pr' ? ALLOW_YEARS_PR : ALLOW_YEARS_CR_CO);
